import { SalesCourseIntakesIntakeDto } from '@wisenet/salesapp-client'
import { useState } from 'react'
import { ErrorBoundary } from '../../components/ErrorBoundary'
import { IntakeContext } from './IntakeContext'
import { IntakePage } from './IntakePage'

export default function Intake() {
  const [selectedCourseIds, setSelectedCourseIds] = useState<string[]>([])

  const [additionalIntakes, setAdditionalIntakes] = useState<SalesCourseIntakesIntakeDto[]>([])

  const [intakeIndex, setIntakeIndex] = useState<{ [key: string]: string }>({})

  const addAdditionalCourses = (intake: SalesCourseIntakesIntakeDto, courseGuid: string) => {
    setIntakeIndex({ ...intakeIndex, [intake.intakeGuid!]: courseGuid })
    setSelectedCourseIds([...selectedCourseIds, courseGuid])
    setAdditionalIntakes([...additionalIntakes, intake])
  }

  const removeAdditionalCourse = (guid: string) => {
    const updatedItems = additionalIntakes.filter(itm => itm.intakeGuid !== guid)
    const updatedCourseIds = selectedCourseIds.filter(id => id !== intakeIndex[guid])
    const updateIntakeIndex = { ...intakeIndex }
    delete updateIntakeIndex[guid]

    setSelectedCourseIds(updatedCourseIds)
    setAdditionalIntakes([...updatedItems])
    setIntakeIndex(updateIntakeIndex)
  }

  const additionalIntakesCount = additionalIntakes.length

  return (
    <ErrorBoundary>
      <IntakeContext.Provider
        value={{
          additionalIntakes,
          additionalIntakesCount,
          addAdditionalCourses,
          removeAdditionalCourse,
          selectedCourseIds,
        }}
      >
        <IntakePage />
      </IntakeContext.Provider>
    </ErrorBoundary>
  )
}
